var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-screen h-screen p-3"},[_c('input',{attrs:{"type":"file"},on:{"change":_vm.onSelectFile}}),_vm._v(" "+_vm._s(_vm.response)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }